module.exports = __webpack_public_path__ + "3d.c0dc06a.png";